import {get} from "./http";
import {jsonPath} from "@/config";
import {getSharedAssetsRevision} from './sharedMiniAssets';

const requireJson = (file)=>{
    const sharedRevision = getSharedAssetsRevision()
    return get(
        `${jsonPath}/${file}`,
        sharedRevision ? {sharedRevision} : {},
        {intact:true},
    )
}


export default requireJson
